<div *ngIf="userDetails" class="dashboard">
    <div class="dashboard__profile card profile-card bg-card-new card-radius-06 border-0 flex-grow">
        <div class="card-body profile-card__body justify-start">
            <div class="w-full section-title">
                <h4>Basic info</h4>
            </div>
            <!-- <div class="profile-row">
                <div class="row-title mb-0">
                   <span> Profile picture</span>
                </div>
                <div class="avatar">
                    <img src="./assets/images/avatars/avatar-3.jpg" alt="">
                </div>
            </div> -->
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'name'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{userDetails.name}}</span>
                </div>
                <!-- <div class="edit-btn">
                    <mat-icon>edit</mat-icon>
                </div> -->
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'email'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{userDetails.email}}</span>
                </div>
                <!-- <div class="edit-btn">
                    <mat-icon>edit</mat-icon>
                </div> -->
            </div>
            <div *ngIf="userDetails.company?.en" class="profile-row">
                <div class="row-title">
                   <span> {{'company'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{userDetails.company?.en}}</span>
                </div>
                <!-- <div class="edit-btn">
                    <mat-icon>edit</mat-icon>
                </div> -->
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'mobile'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{userDetails.mobile}}</span>
                </div>
                <!-- <div class="edit-btn">
                    <mat-icon>edit</mat-icon>
                </div> -->
            </div>
        </div>
    </div>
    <div class="dashboard__address card address-card address-card--featured bg-card-new card-radius-06 border-0"
        *ngIf="address">
        <!-- <div class="address-card__badge">{{"default_address"|translate}}</div> -->
        <div class="address-card__body">
            <div class="flex flex-row justify-between">
                <div class="w-full section-title">
                    <h4>{{"address" | translate}}</h4>
                </div>
                <div class="default_badge">{{"default_address"|translate}}</div>
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'name'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{address.name}}</span>
                </div>
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'email'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{userDetails.email}}</span>
                </div>
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'building'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{address.building}}</span>
                </div>
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'road'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{address.road}}</span>
                </div>
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'block'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{address.block}}{{address.city}}</span>
                </div>
            </div>
            <div class="profile-row">
                <div class="row-title">
                   <span> {{'country'|translate}}</span>
                </div>
                <div class="row-info">
                    <span>{{address.country}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="dashboard__orders card bg-card-new card-radius-06 border-0">
        <div class="card-header">
            <h4 class="section-title">{{"recent_orders"|translate}}</h4>
        </div>

        <div class="card-table">
            <div class="table-responsive-sm mx-8">
                <table>
                    <thead>
                        <tr>
                            <th>{{"order"|translate}}</th>
                            <th>{{"date"|translate}}</th>
                            <th>{{"status"|translate}}</th>
                            <th>{{"total"|translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let order of orders">
                            <td><a class="color-accent" [routerLink]="['/account/orders/' , order.orderId]">#{{ order.orderId }}</a></td>
                            <td>{{ order.orderDate |date }}</td>
                            <td>{{ order.status }}</td>
                            <td>{{ order.total| currencyConvert : order.currencyMeta?.code }} for {{ order.quantity }} item(s)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
